import { apiSlice } from "../apiSlice";
import { dateTFormat } from "../../utility/Utility";
import { Order } from "../../views/Orders/OrderList";
import { AssignCartToOrderRequest } from "../deliveryOrderSlice";
import { GetTentativeGroupOrdersResponse } from "../deliveryRouteOptimizer";
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PROD;
export interface GetSetMenuItemsResponse {
  items: Array<any>;
}

export interface StatusUpdateRequestData {
  orderId: string | undefined;
  orderStatus: string;
  updateNote: string;
  orderTakenBy?: { displayName: string; userId: string };
}

export interface GetSearchRequest {
  hits: any;
  params: string;
}
export interface OrderID {
  id: string;
}

export interface CreateOrderData {
  address: string | undefined;
  cartId: any;
  displayName: string;
  imageUrl: string;
  orderCreatedBy: string;
  paymentMethod: string;
  restaurantId: string;
  customerId?: string | null;
  deliveryTime?: any;
  isScheduledOrder: boolean;
  totalPrice: number;
  orderItems: any;
  isTentativeOrder: boolean;
  orderStatus?: string | null;
  orderSource: "CallCenter";
  onlinePaymentReference?: string;
  deliveryInstructions?: string;
  deliveryContactName?: string;
  deliveryContactPhoneNumber?: string;
  orderNote?: string;
  organizationId?: string | null;
  isCorporateOrder?: boolean | null;
  promoCode?: string | null;
  orderTimeSlot?: string;
  manualDeliveryFee?: number;
  manualDiscount?: {
    type: string;
    amount: number;
  };
}

export interface GetOrderPaymentBreakdownRequest {
  cartId: string;
  orderItems: Array<{
    displayName?: string;
    menuItemId?: string;
    quantity?: number;
    unitPrice?: number;
    itemType?: String;
    portionSize?: string;
    orderCreatedBy?: string;
    customItems?: Array<{
      displayName?: string;
      menuItemId?: string;
      unitPrice?: number;
    }>;
    perItemManualDiscount?: number | undefined;
  }>;
  restaurantId: string;
  totalPrice: number;
  isDeliveryOrder?: boolean;
  promoCode?: string;
  manualDeliveryFee?: number | undefined;
  manualDiscount?: {
    type: string | undefined;
    amount: number | undefined;
  };
}

export interface GetOrderPaymentBreakdownResponse {
  totalPrice: number;
  cartCommission: number;
  netAmount: number;
  deliveryFee?: number;
}

export interface IssueBulkOrderRequest {
  orderIds: string[];
}

export interface UpdateOrderRequest {
  orderId: string;
  totalPrice?: number;
  paymentMethod?: string;
  orderStatus?: string;
  promoCode?: string;
  orderItems?: Array<{
    displayName?: string;
    menuItemId?: string;
    quantity?: number;
    unitPrice?: number;
    itemType?: String;
    portionSize?: string;
    orderCreatedBy?: string;
    customItems?: Array<{
      displayName?: string;
      menuItemId?: string;
      unitPrice?: number;
    }>;
  }>;
  isDeliveryOrder?: boolean;
  manualDeliveryFee?: number | undefined;
  manualDiscount?: {
    type: string | undefined;
    amount: number | undefined;
  };
  orderNote?: string;
  packingNote?: string;
  paymentNote?: string;
}

export interface updateOrderResponse {
  isScheduledOrder: boolean;
  totalPrice: number;
  isDirectRestaurantOrder: boolean;
  walletPaymentAmount: number;
  orderId: string;
  customer: {
    id: string;
    displayName: string;
    userId: string;
  };
  cart: {
    cartId: string;
    cartPersonId: string;
    userId: string;
    displayName: string;
  };
  restaurantId: string;
  address: string;
  photoUrl: string;
  paymentMethod: string;
  displayName: string;
  orderStatus: string;
  orderItems?: Array<{
    displayName?: string;
    menuItemId?: string;
    quantity?: number;
    unitPrice?: number;
    itemType?: String;
    portionSize?: string;
    orderCreatedBy?: string;
    customItems?: Array<{
      displayName?: string;
      menuItemId?: string;
      unitPrice?: number;
    }>;
  }>;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  orderCreatedBy: string;
  orderReference: string;
  deliverAt?: {
    _seconds: number;
    _nanoseconds: number;
  };
  paymentSummary: {
    totalPrice: number;
    cartCommission: number;
    netAmount: number;
    cardPaymentAmount: number;
    cashPaymentAmount: number;
    walletPaymentAmount: number;
  };
}

interface CheckDeliveryLocationRequest {
  point: {
    latitude: number;
    longitude: number;
  };
  restaurantId: string;
}

interface CheckDeliveryLocationResponse {
  isInsideDeliveryZone: boolean;
  isDeliveryFree: boolean;
}

export interface CreateGroupPayload {
  restaurantId: string;
  groupOrderName: string;
  orderIds: string[];
  groupOrderId?: string;
}

export interface AssignCartToTentativeOrderRequest {
  restaurantId?: string;
  groupOrderId?: string;
  cartId: string;
  deliveryCartId?: string | null;
}

export interface CreateGroupOrderRequest {
  groupOrders: Array<{
    restaurantId: string;
    cartId: string;
    orderIds: string[];
    tentativeGroupOrderId: string;
  }>;
}

export interface DeleteTentativeGroupOrderRequest {
  restaurantId: string;
  groupOrderId: string;
}

export interface DeleteTentativeGroupOrderResponse {
  success: boolean;
  message?: string;
}

export interface UpdateGroupOrderStatusRequest {
  groupOrderId?: string;
  groupOrderStatus?: string;
}

export interface IssuePickupOrderRequest {
  orderId: string;
  paymentMethod: string;
  customerAppCardPayment?: boolean;
}

export interface IssuePickupOrderResponse {
  transactionReference: string;
}

export interface AssignDeliveryPartnerToOrderRequest {
  orderId: string;
  deliveryCartId: string;
}

export interface AssignDeliveryPartnerToOrderResponse {
  success: boolean;
  message?: string;
  data?: {
    orderId: string;
    deliveryCart?: {
      cartId: string;
      displayName: string;
      cartPersonId: string;
      userId: string;
    }
  };
}

const ALGOLIA_APP_ID = process.env.REACT_APP_ALGOLIA_APP_ID_PROD;

const ALGOLIA_API_KEY = process.env.REACT_APP_ALGOLIA_API_KEY_PROD;

export const orderService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllOrders: builder.mutation<
      GetSetMenuItemsResponse,
      { restaurantId: string; startDate: string }
    >({
      query: ({ restaurantId, startDate }) => {
        const url = `https://adminhttps-getorderlist${API_BASE_DOMAIN}?restaurantId=${restaurantId}&startDate=${startDate}&orderStatus=All`;
        return {
          url,
          method: "GET",
          responseHandler: (response) => response.json(),
        };
      },
    }),

    getAllOrderss: builder.query<GetSetMenuItemsResponse, string>({
      query: (restaurantId) => {
        const startDate = encodeURIComponent(dateTFormat(new Date()));
        const encodedRestaurantId = encodeURIComponent(restaurantId);
        return `https://adminhttps-getorderlist${API_BASE_DOMAIN}?restaurantId=${encodedRestaurantId}&startDate=${startDate}`;
      },
    }),

    getOrderList: builder.mutation<
      GetSetMenuItemsResponse,
      {
        orderStatus?: string;
        restaurantId: string;
        startDate: string;
        endDate?: string;
        isDeliveryOrder: boolean;
        onlyApproved?: boolean;
        cartId?: string;
      }
    >({
      query: ({
        orderStatus,
        restaurantId,
        startDate,
        endDate,
        isDeliveryOrder,
        onlyApproved,
        cartId,
      }) => {
        let url = `https://adminhttps-getorderlist${API_BASE_DOMAIN}/?restaurantId=${encodeURIComponent(
          restaurantId,
        )}&startDate=${encodeURIComponent(startDate)}`;

        if (endDate) {
          url += `&endDate=${encodeURIComponent(endDate)}`;
        }

        if (orderStatus && orderStatus !== "All") {
          url += `&orderStatus=${encodeURIComponent(orderStatus)}`;
        }

        if (isDeliveryOrder !== undefined) {
          url += `&isDeliveryOrder=${isDeliveryOrder}`;
        }

        if (onlyApproved !== undefined) {
          url += `&onlyApproved=${onlyApproved}`;
        }
        if (cartId) {
          url += `&cartId=${encodeURIComponent(cartId)}`;
        }

        return {
          url,
          method: "GET",
          responseHandler: (response) => response.json(),
        };
      },
    }),

    getOrdersByDateAndStatus: builder.query<
      void,
      {
        orderStatus: string;
        restaurantId: string;
        startDate: string;
        endDate: string;
      }
    >({
      query: ({ orderStatus, restaurantId, startDate, endDate }) => {
        return {
          url: `https://adminhttps-getorderlist${API_BASE_DOMAIN}?orderStatus=${orderStatus}&restaurantId=${restaurantId}&startDate=${startDate}&endDate=${endDate}`,
          method: "GET",
          responseHandler: (response) => response.text(),
        };
      },
      providesTags: ["Order"],
    }),

    orderStatusUpdate: builder.mutation<string, StatusUpdateRequestData>({
      query: (data) => ({
        url: `https://adminhttps-updateorderstatus${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),

    createOrder: builder.mutation<string, CreateOrderData>({
      query: (data) => ({
        url: `https://adminhttps-createorder${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),

    getUserTypeWiseSearchResults: builder.mutation<GetSearchRequest, any>({
      query: (data) => ({
        url: `https://${ALGOLIA_APP_ID}-dsn.algolia.net/1/indexes/UserSearchDocuments/query`,
        method: "POST",
        body: data,
        headers: {
          "X-Algolia-Application-Id": `${ALGOLIA_APP_ID}`,
          "X-Algolia-API-Key": `${ALGOLIA_API_KEY}`,
        },
      }),
    }),

    getCartSearchResults: builder.mutation<GetSearchRequest, any>({
      query: (data) => ({
        url: `https://${ALGOLIA_APP_ID}-dsn.algolia.net/1/indexes/CartSearchDocuments/query`,

        method: "POST",
        body: data,
        headers: {
          "X-Algolia-Application-Id": `${ALGOLIA_APP_ID}`,
          "X-Algolia-API-Key": `${ALGOLIA_API_KEY}`,
        },
      }),
    }),

    getOrganizationSearchResults: builder.mutation<GetSearchRequest, any>({
      query: (data) => ({
        url: `https://${ALGOLIA_APP_ID}-dsn.algolia.net/1/indexes/OrganizationSearchDocuments/query`,

        method: "POST",
        body: data,
        headers: {
          "X-Algolia-Application-Id": `${ALGOLIA_APP_ID}`,
          "X-Algolia-API-Key": `${ALGOLIA_API_KEY}`,
        },
      }),
    }),

    getUserSearchResults: builder.mutation<GetSearchRequest, any>({
      query: (data) => ({
        url: `https://${ALGOLIA_APP_ID}-dsn.algolia.net/1/indexes/UserSearchDocuments/query`,
        method: "POST",
        body: data,
        headers: {
          "X-Algolia-Application-Id": `${ALGOLIA_APP_ID}`,
          "X-Algolia-API-Key": `${ALGOLIA_API_KEY}`,
        },
      }),
    }),

    findOrderDataByOrderId: builder.mutation<Order, string>({
      query: (OrderID) => ({
        url: `https://adminhttps-getorderbyid${API_BASE_DOMAIN}?orderId=${OrderID}`,
        method: "GET",
      }),
    }),

    getOrderPaymentBreakdown: builder.mutation<
      GetOrderPaymentBreakdownResponse,
      GetOrderPaymentBreakdownRequest
    >({
      query: (data) => ({
        url: `https://adminhttps-getorderpaymentbreakdown${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.json(),
      }),
    }),

    updateBulkOrderStatus: builder.mutation<
      string,
      {
        orderIds: string[];
        orderStatus: string;
        orderTakenBy?: { displayName: string; userId: string };
      }
    >({
      query: (data) => ({
        url: `https://adminhttps-updatebulkorderstatus${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),

    issueBulkOrder: builder.mutation<string, IssueBulkOrderRequest>({
      query: (data) => ({
        url: `https://adminhttps-issuebulkorder${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),
    updateOrder: builder.mutation<updateOrderResponse, UpdateOrderRequest>({
      query: (data) => ({
        url: `https://adminhttps-updateorder${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.json(),
      }),
    }),
    assignCartToOrder: builder.mutation<any, AssignCartToOrderRequest>({
      query: (data) => ({
        url: `https://adminhttps-assigncarttoorder${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),

    checkDeliveryLocation: builder.query<
      CheckDeliveryLocationResponse,
      CheckDeliveryLocationRequest
    >({
      query: ({ point, restaurantId }) => ({
        url: `https://customersitehttps-checkpointinsidedeliveryzone${API_BASE_DOMAIN}/`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: { point, restaurantId },
      }),
    }),
    createGroup: builder.mutation<any, CreateGroupPayload>({
      query: (data) => ({
        url: `https://adminhttps-createtentativegrouporder${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.json(),
      }),
      invalidatesTags: ["Order"],
    }),
    getTentativeGroupOrders: builder.query<
      GetTentativeGroupOrdersResponse[],
      { restaurantId: string }
    >({
      query: ({ restaurantId }) => ({
        url: `https://adminhttps-gettentativegrouporders${API_BASE_DOMAIN}`,
        method: "GET",
        params: {
          restaurantId: restaurantId,
        },
        responseHandler: (response) => response.json(),
      }),
      providesTags: ["Order"],
    }),
    assignCartToTentativeOrder: builder.mutation<
      any,
      AssignCartToTentativeOrderRequest
    >({
      query: (data) => ({
        url: `https://adminhttps-assigncarttotentativeorder${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.json(),
      }),

      invalidatesTags: ["Order"],
    }),
    createGroupOrder: builder.mutation<any, CreateGroupOrderRequest>({
      query: (data) => ({
        url: `https://adminhttps-creategrouporder${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Order"],
    }),
    deleteTentativeGroupOrder: builder.mutation<
      any,
      DeleteTentativeGroupOrderRequest
    >({
      query: (data) => ({
        url: `https://adminhttps-deletetentativegrouporders${API_BASE_DOMAIN}/?restaurantId=${data.restaurantId}&groupOrderId=${data.groupOrderId}`,
        method: "DELETE",
        responseHandler: (response) => response.json(),
      }),
      invalidatesTags: ["Order"],
    }),
    updateGroupOrderStatus: builder.mutation<
      string,
      UpdateGroupOrderStatusRequest
    >({
      query: (data) => ({
        url: `https://adminhttps-updategrouporderstatus${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ["Order"],
    }),
    removeOrderFromGroupOrder: builder.mutation<
      RemoveOrderFromGroupOrderResponse,
      RemoveOrderFromGroupOrderRequest
    >({
      query: (data) => ({
        url: `https://adminhttps-removeorderfromgrouporder${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.json(),
      }),
      invalidatesTags: ["Order"],
    }),
    getCustomerDetailsById: builder.mutation<any, string>({
      query: (customerId) => ({
        url: `https://adminhttps-getcustomerdetails${API_BASE_DOMAIN}?customerId=${customerId}`,
        method: "GET",
        responseHandler: (response) => response.json(),
      }),
    }),
    issuePickupOrder: builder.mutation<
      IssuePickupOrderResponse,
      IssuePickupOrderRequest
    >({
      query: (data) => ({
        url: `https://cartapphttps-issuepickuporder${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.json(),
      }),
    }),
    assignDeliveryPartnerToOrder: builder.mutation<
      AssignDeliveryPartnerToOrderResponse,
      AssignDeliveryPartnerToOrderRequest
    >({
      query: (data) => ({
        url: `https://adminhttps-assigndeliverycartfororder${API_BASE_DOMAIN}`,
        method: "PUT",
        body: data,
        responseHandler: (response) => response.json(),
      }),
    }),
    dispatchDeliveryOrderForDeliveryPartner: builder.mutation<
      any,
      { orderId: string;}
    >({
      query: (data) => ({
        url: `https://adminhttps-dispatchedorderbyadmin${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),
  }),
});

export const {
  useGetAllOrdersMutation,
  useGetAllOrderssQuery,
  useLazyGetAllOrderssQuery,
  useGetOrderListMutation,
  useGetOrdersByDateAndStatusQuery,
  useOrderStatusUpdateMutation,
  useCreateOrderMutation,
  useGetUserTypeWiseSearchResultsMutation,
  useGetCartSearchResultsMutation,
  useGetUserSearchResultsMutation,
  useFindOrderDataByOrderIdMutation,
  useGetOrderPaymentBreakdownMutation,
  useUpdateBulkOrderStatusMutation,
  useIssueBulkOrderMutation,
  useUpdateOrderMutation,
  useAssignCartToOrderMutation,
  useLazyCheckDeliveryLocationQuery,
  useGetOrganizationSearchResultsMutation,
  useCreateGroupMutation,
  useLazyGetTentativeGroupOrdersQuery,
  useAssignCartToTentativeOrderMutation,
  useCreateGroupOrderMutation,
  useDeleteTentativeGroupOrderMutation,
  useUpdateGroupOrderStatusMutation,
  useGetCustomerDetailsByIdMutation,
  useIssuePickupOrderMutation,
  useAssignDeliveryPartnerToOrderMutation,
  useDispatchDeliveryOrderForDeliveryPartnerMutation,
  useRemoveOrderFromGroupOrderMutation,
} = orderService;

export interface RemoveOrderFromGroupOrderRequest {
  restaurantId: string;
  groupOrderId: string;
  orderId: string;
}

export interface RemoveOrderFromGroupOrderResponse {
  message: string;
  data?: { groupCancelled: boolean };
}
